import React from 'react';
import { Box } from '@mui/material';
import { TopBar } from './TopBar';

export const CustomerLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Box sx={{
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    background: 'radial-gradient(ellipse 90% 60% at 50% 0%, #DCE4F0 0%, #EEF2F8 60%)',
  }}>
    <TopBar
      onMenuClick={() => { /* no-op for customer */ }}
      onSidebarToggle={() => { /* no-op for customer */ }}
      sidebarCollapsed={true}
    />
    <Box component="main" sx={{ flex: 1 }}>
      {children}
    </Box>
  </Box>
);
